import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LazyMotion, domAnimation } from 'framer-motion';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';

const Home = lazy(() => import('./pages/Home'));
const Demo = lazy(() => import('./pages/Demo'));
const TelCoManager = lazy(() => import('./pages/TelCoManager'));
const Contact = lazy(() => import('./pages/Contact'));
const About = lazy(() => import('./pages/About'));
const Achievement = lazy(() => import('./pages/Achievement'));

const PageLoader = () => (
  <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-[#4B7BF5]/30 border-t-[#4B7BF5] rounded-full animate-spin" />
  </div>
);

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <LazyMotion features={domAnimation} strict>
          <Router>
            <ScrollToTop />
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/demo/telco-manager" element={<TelCoManager />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/achievement" element={<Achievement />} />
              </Routes>
            </Suspense>
          </Router>
        </LazyMotion>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
